import React from 'react';
import { Fragment } from 'react';
import {DataRPC, News, ImageText} from '../../rpc-client/DataRPC';
import ReactHtmlParser from "react-html-parser";
import './DetailPage.css';

class Details extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            content: "",
            name: "",
            create_date: "",
            description: "",
            ava: "",
            
            news_title: "",
            news_desc: "",
            news_image: ""
        }
    }

    async componentDidMount() {

        let id = this.props.match.params.id;

        new DataRPC().fetchData('GetNews', {
            id: id,
            type: 1
        }, News).then(gData => { 
            if (gData) {
                console.log(gData);

                this.setState({
                    content: gData.content,
                    name: gData.name,
                    create_date: gData.create_date,
                    description: gData.description,
                    ava: gData.ava
                });
            }
        });

        new DataRPC().fetchData('GetImageText', {
            page: "news"
        }, ImageText).then(gData => { 
            if (gData) {
                this.setState({news_title: gData.find(x => x.komoku === "news_title").content});
                this.setState({news_desc: gData.find(x => x.komoku === "news_desc").content});
                this.setState({news_image: gData.find(x => x.komoku === "news_image").content});
            }
        });
    }

    render() {
        return( 
            <Fragment>

                <section className="hc-detail-hero" style={{backgroundImage: `url(${this.state.news_image})`}}>
                    <div className="hc-container">
                        <div className="hc-detail-hero-inner">
                            <span>{this.state.news_title}</span>
                            <h1>{this.state.news_desc}</h1>
                        </div>
                    </div>
                </section>

                <section className="hc-detail-body">
                    <div className="hc-container">
                        <div className="hc-detail-card">
                            <img src={this.state.ava} alt=""/>

                            <div className="hc-detail-content">
                                <div className="hc-detail-meta">
                                    <span><i className="icofont-book-mark"></i> Tin tức</span>
                                    <span><i className="icofont-calendar"></i> {this.state.create_date}</span>
                                </div>

                                <h2>{this.state.name}</h2>

                                <p className="hc-detail-lead">{this.state.description}</p>

                                <div className="hc-detail-prose">
                                    {ReactHtmlParser(this.state.content)}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </Fragment>
        )
    }

}

export default Details;